<template>
  <div class="content">
    <el-menu default-active="list" class="el-menu-demo" mode="horizontal">
      <el-menu-item index="list" class="is-active">角色管理</el-menu-item>
    </el-menu>
    <div class="tab-item">
      <el-button class="left" id="add" type="primary" @click="create()">添加角色</el-button>
      <el-dialog title="添加角色" :visible.sync="createDialogVisible" @close="closeCreate">
        <el-form :model="createForm" ref="createForm" :rules="createRules" label-width="70px" class="form">
          <el-form-item label="用户名" prop="name">
            <el-input v-model="createForm.name"></el-input>
          </el-form-item>
          <el-form-item label="编码" prop="code">
            <el-input v-model="createForm.code"></el-input>
          </el-form-item>

          <el-form-item label="用户组" prop="roles">
            <el-tree :data="permission" show-checkbox node-key="code" :props="defaultProps" ref="createPermission" v-if="permission.length > 0"></el-tree>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('createForm', createRole)">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <el-table stripe :data="roles">
      <el-table-column prop="name" label="用户名" width="250">
      </el-table-column>
      <el-table-column prop="code" label="编码" width="250"> </el-table-column>
      <el-table-column label="注册时间" min-width="150">
        <template slot-scope="scope">
          {{ common.date("Y-m-d H:i:s", scope.row.createdTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" @click="deleteRole(scope.row.id)" :disabled="unableDelete.indexOf(scope.row.code) > -1">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="pageChange" background layout="total, prev, pager, next" :total="paginator.itemCount" :page-size="20" v-if="paginator" hide-on-single-page>
    </el-pagination>
    <el-dialog title="编辑用户" :visible.sync="editDialogVisible" @close="closeEdit">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="70px" class="form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="editForm.code" disabled></el-input>
        </el-form-item>

        <el-form-item label="用户组" prop="roles">
          <el-tree :data="permission" show-checkbox node-key="code" :props="defaultProps" ref="editPermission"></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEdit">取 消</el-button>
        <el-button type="primary" @click="submitForm('editForm', editRole)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  rolesList,
  rolesTree,
  getRolePermission,
  editRolePermission,
  checkRoleName,
  checkRoleCode,
  createRole,
  deleteRole
} from "@/api/roles";
import qs from "qs";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  data() {
    //检查是否重复名称
    const validateCheckName = (rule, value, callback) => {
      var params = {
        value: value,
        exclude: this.editName
      };
      checkRoleName(params).then(response => {
        if (response.data.success == true) {
          callback();
        } else {
          callback(new Error(response.data.message));
        }
      });
    };
    //检查是否重复编码
    const validateCheckCode = (rule, value, callback) => {
      var params = {
        value: value,
        exclude: this.editCode
      };
      checkRoleCode(params).then(response => {
        if (response.data.success == true) {
          callback();
        } else {
          callback(new Error(response.data.message));
        }
      });
    };
    return {
      createDialogVisible: false,
      editDialogVisible: false,
      editId: 0,
      editName: "",
      editCode: "",
      createForm: {
        name: "",
        code: "",
        data: []
      },
      editForm: {
        name: "",
        code: "",
        data: []
      },
      createRules: {
        name: [
          { required: true, trigger: "blur", message: "请输入名称" },
          {
            min: 1,
            max: 20,
            message: "用户名的长度必须小于等于20，一个中文字算2个字符",
            trigger: "blur"
          },
          { required: true, trigger: "blur", validator: validateCheckName }
        ],
        code: [
          { required: true, trigger: "blur", message: "请输入编码" },
          {
            min: 1,
            max: 20,
            message: "编码的长度必须小于或等于20",
            trigger: "blur"
          },
          { required: true, trigger: "blur", validator: validateCheckCode }
        ]
      },
      editRules: {
        name: [
          { required: true, trigger: "blur", message: "请输入名称" },
          {
            min: 1,
            max: 20,
            message: "用户名的长度必须小于等于20，一个中文字算2个字符",
            trigger: "blur"
          },
          { required: true, trigger: "blur", validator: validateCheckName }
        ]
      },
      allRoles: null,
      roles: null,
      permission: [],
      paginator: null,
      defaultProps: {
        children: "children",
        label: "name"
      },
      conditions: {
        page: 1
        // keyword: "",
        // keywordType: "nickname",
        // roles: "ROLE_USER"
      },
      //禁止删除列表
      unableDelete: [
        "ROLE_USER",
        "ROLE_TEACHER",
        "ROLE_ADMIN",
        "ROLE_SUPER_ADMIN",
        "ROLE_ADMIN_CHILD",
        "ROLE_SUP_ADMIN_CHILD"
      ]
    };
  },
  created() {
    this.handle();
  },
  methods: {
    handle() {
      var params = this.conditions;
      // params.status = 1;
      rolesList(params).then(response => {
        this.roles = response.data.roles;
        this.allRoles = response.data.allRoles;
        this.paginator = response.data.paginator;
      });
    },
    search() {
      this.conditions.page = 1;
      this.handle();
    },
    pageChange(val) {
      this.conditions.page = val;
      this.handle();
    },
    submitForm(formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();
        } else {
          return false;
        }
      });
    },
    create() {
      this.editName = "";
      this.editCode = "";
      rolesTree().then(response => {
        this.permission = JSON.parse(response.data.menus);
      });
      this.createDialogVisible = true;
    },
    edit(index, row) {
      this.editName = row.name;
      this.editCode = row.code;
      this.editId = row.id;
      getRolePermission(row.id).then(response => {

        this.permission = JSON.parse(response.data.menus);
        this.editForm.name = response.data.role.name;
        this.editForm.code = response.data.role.code;
        var data = response.data.role.data;
        this.$nextTick(() => {
          data.forEach(item => {
            this.$refs.editPermission.setChecked(item, true, false);
          });
        });
      });
      this.editDialogVisible = true;
    },
    closeCreate() {
      this.$refs["createForm"].resetFields();
      this.createForm = {
        name: "",
        code: "",
        data: []
      };
    },
    closeEdit() {
      this.$refs["editForm"].resetFields();
      this.editDialogVisible = false;
      this.$refs.editPermission.setCheckedKeys([]);
      this.permission = [];
      this.editForm = {
        name: "",
        code: "",
        data: []
      };
    },
    //封禁
    lockUser(id) {
      lockUser(id).then(response => {

        this.$message.success({
          message: "封禁成功"
        });
        this.handle();
      });
    },
    //解禁
    unlockUser(id) {
      unlockUser(id).then(response => {

        this.$message.success({
          message: "解禁成功"
        });
        this.handle();
      });
    },
    createRole() {
      var params = this.createForm;
      var data = this.$refs.createPermission.getHalfCheckedKeys();
      params["data"] = JSON.stringify(
        data.concat(this.$refs.createPermission.getCheckedKeys())
      );
      createRole(qs.stringify(this.createForm)).then(response => {
        if (response.code == 200) {
          this.$message.success({
            message: "创建成功"
          });
          this.createDialogVisible = false;
          this.createForm = {
            nickname: "",
            email: "",
            confirmPassword: "",
            mobile: "",
            roles: ["ROLE_USER"]
          };
          this.handle();
        }
      });
    },
    deleteRole(id) {
      let that = this;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteRole(id).then(response => {
          if (response.code == 200) {
            this.$message.success({
              message: "删除成功"
            });
            this.handle();
          } else {
            this.$message.error({
              message: "删除失败"
            });
          }
        });
      });
    },
    editRole() {
      var params = this.editForm;

      var data = this.$refs.editPermission.getHalfCheckedKeys();
      params["data"] = JSON.stringify(
        data.concat(this.$refs.editPermission.getCheckedKeys())
      );
      editRolePermission(this.editId, qs.stringify(params)).then(response => {
        if (response.code == 200) {
          this.$message.success({
            message: "修改成功"
          });
          this.closeEdit();
        }
      });

      //   editRole(this.editId, qs.stringify(this.editForm)).then(response => {
      //     if (response.code == 200) {
      //       this.$message.success({
      //         message: "修改成功"
      //       });
      //       this.editDialogVisible = false;
      //       this.editForm = {
      //         nickname: "",
      //         email: "",
      //         confirmPassword: "",
      //         mobile: "",
      //         roles: []
      //       };
      //       this.handle();
      //     }
      //   });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.el-card {
  line-height: 32px;
  margin-bottom: 20px;
}
.course_title {
  color: #000000;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list_info {
  overflow: hidden;
}
.list_info span {
  display: inline-block;
  margin-right: 15px;
}
.tools {
  height: 100%;
  text-align: right;
  line-height: 64px;
}
.status_wrapper {
  overflow: hidden;
}
.status {
  float: left;
  width: 50px;
  height: 29px;
  text-align: center;
  line-height: 30px;
}

.tab-item {
  margin-top: 5px;
  overflow: hidden;
}
.tab-item ul {
  width: 800px;
  overflow: hidden;
  float: left;
}
.tab-item ul li {
  margin-left: 10px;
  display: block;
  padding: 5px 15px;
  cursor: pointer;
  float: left;
}
.active {
  background-color: #1e9fff;
  color: #ffffff;
}
.form {
  padding: 0 80px;
}
.toolbar {
  width: 100%;
  margin: 10px 0;
  padding: 5px;
  overflow: hidden;
  margin-bottom: 10px;
}
.toolbar > * {
  margin-right: 10px;
}
.toolbar .el-form > * {
  margin-right: 10px;
}
.select {
  width: 130px;
}
.search {
  width: 180px;
}
.tab-item > .up_item {
  width: 100%;
  height: 145px;
  margin-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}
.el-tree {
  margin-top: 7px;
}
</style>
